import { render, staticRenderFns } from "./RoleList.vue?vue&type=template&id=8b42ac50&"
import script from "./RoleList.js?vue&type=script&lang=js&"
export * from "./RoleList.js?vue&type=script&lang=js&"
import style0 from "./RoleList.vue?vue&type=style&index=0&id=8b42ac50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports